const isSecurityError = (error: unknown): boolean =>
  error instanceof DOMException && error.name === "SecurityError";

// Firefox 157+ rejects History calls from a document that is no longer fully
// active. vue-router saves the scroll position on pagehide/visibilitychange,
// which still run while a cross-site iframe is torn down: the document is
// gone, nothing is lost. A URL-less replaceState has no other way to be
// insecure, so only that shape is swallowed (WEB-READER-1CNV)
export const ignoreReplaceStateInHiddenDocument = (
  target: History = window.history
): void => {
  const { replaceState } = target;
  target.replaceState = function (data, unused, url) {
    try {
      replaceState.call(this, data, unused, url);
    } catch (error) {
      if (
        url != null ||
        document.visibilityState !== "hidden" ||
        !isSecurityError(error)
      ) {
        throw error;
      }
    }
  };
};
